const products = {
    MemberCenter: "MC",
    Billable: "BILLABLE",
    RemoteDonationCenter: "RDN",
    Vxm: "VXM",
    DonorProtectionAddendumSigned: "DPA",
    KidneyForLifeActive: "K4L",
    KidneyForLifeFullyUtilized: "K4LFU",
    KidneyForLifeUtilization: "K4LUT",
    VoucherEducationModule: "VEM",
    PartnerCenter: "PC",
    AllInAddendumSigned: "ALLIN",
    VoucherProgramActive: "VP",
    DashActive: "KDASH",
    DashFullyUtilized: "KDASHFU",
    PwlActive: "PWL",
    PwlFullyUtilized: "PWLFU",
    AutomatedDonorFollowUpActive: "DFUP",
    AutomatedDonorFollowUpFullyUtilized: "DFUPFU",
    HomeBloodDrawCountTarget: "CHBD",
    LiverDashActive: "LDASH",
    OptInAutomatedSerologies: "SS",
    DirectStreamlinedSerologyCount: "DD",
    MicrositesActive: "MS",
    MicrositesFullyUtilized: "MSFU",
    CompletedMoreThan0PatientTrainingSessions: "PTS",
    CompletedMoreThan2PatientTrainingSessions: "PTS2",
    AcceptingDonorReferrals: "RD",
    AcceptingPatientReferrals: "RP",
    IsAcceptingPatientReferralsForMicrosites: "RM",
    AcceptingKfLPatientReferrals: "RK4LP",
    AutomatedCollectionsAndClearing: "ACC",
    StreamlinedBillingService: "SBS",
    IncludedInCenterListingService: "CLS",
    DonorShieldDirectUser: "DSD",
    DonorShieldDirectFullyUtilized: "DSDFU",
    DonorCareNetworkCenter: "DCN",
    OfferDonorConnect: "ODC",
    ExpertSystem: "ES",
    DonorShieldDirectLiver: "DSDL"
}

export default products;